import { render, staticRenderFns } from "./MonthlyRISS.vue?vue&type=template&id=5897c761"
import script from "./MonthlyRISS.vue?vue&type=script&lang=js"
export * from "./MonthlyRISS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports